import * as _confetti from 'canvas-confetti';

export const confetti = _confetti;
